import styled, { keyframes } from 'styled-components';
import { withQuery } from '../../core/themev2';
import { selectColor } from '../../core/theme';

const fadeIn = keyframes`
  0% {
   opacity: 0;
  }
  80% {
    opacity: 1;
  }
`;
const fadeInAndOut = keyframes`
  0%,100% { opacity: 0 }
  90%,10% { opacity: 1 }
`;

const ContentLayout = styled.div`
  position: absolute;
  display: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: 1;
  animation: ${props => (props.startupAnimation ? fadeInAndOut : fadeIn)} linear;
  animation-duration: ${props => (props.startupAnimation ? '4.2s' : '0.2s')};
  z-index: 1;
  font-size: ${props => (props.isSecundary ? '16px' : 'auto')};
  &.top {
    left: -${({ tooltipWidth, hoverRect }) => tooltipWidth / 2 - hoverRect.width / 2 - 1}px;
    top: -${({ tooltipHeight }) => tooltipHeight + 4}px;
    ${withQuery.sm.down()} {
      left: ${props => props.isSecundary && props.containerLeft};
    }
  }
  &.left {
    left: -${({ tooltipWidth }) => tooltipWidth + 4}px;
    top: -${({ tooltipHeight, hoverRect }) => tooltipHeight / 2 - hoverRect.height / 2}px;
  }
  &.right {
    left: ${({ hoverRect }) => hoverRect.width + 8}px;
    top: -${({ tooltipHeight, hoverRect }) => tooltipHeight / 2 - hoverRect.height / 2}px;
  }
  &.bottom {
    left: -${({ tooltipWidth, hoverRect }) => tooltipWidth / 2 - hoverRect.width / 2 - 6}px;
    bottom: -${({ tooltipHeight }) => tooltipHeight + 4}px;
  }

  .label {
    color: #fff;
    text-align: center;
    background-color: ${props => selectColor(props.backgroundColor || 'blueDark')};
    border-radius: 4px;
    text-align: left;
    &.simple {
      padding: ${props => (props.isSecundary ? '8px 16px 8px 16px' : '0px 8px')};
    }
    &.informative {
      padding: 4px 8px;
      white-space: normal;
      width: 240px;
    }
    &.interactive {
      padding: 8px;
      width: fit-content;
      height: fit-content;
    }
  }

  .tooltip-arrow {
    z-index: -1;
    width: 8px;
    height: 8px;
    transform: rotate(45deg);
    background-color: ${selectColor('blueDark')};
    position: absolute;
    &.left-arrow {
      right: -2px;
      top: ${({ tooltipHeight }) => tooltipHeight / 2 - 3}px;
    }
    &.top-arrow {
      bottom: -2px;
      right: ${({ tooltipWidth }) => tooltipWidth / 2 - 3}px;
      ${withQuery.sm.down()} {
        right: ${props => props.isSecundary && props.arrowRight};
      }
    }
    &.right-arrow {
      left: -2px;
      top: ${({ tooltipHeight }) => tooltipHeight / 2 - 3}px;
    }
    &.bottom-arrow {
      top: -2px;
      right: ${({ tooltipWidth }) => tooltipWidth / 2 - 3}px;
    }
  }
`;

export { ContentLayout };
